export default __webpack_public_path__ + "static/media/solution.89f02760.svg";